/* global axios */
import ApiClient from '../ApiClient';

// Prime Insight — manual transfer of a real conversation to a "+ Recursos" agent,
// triggered by an attendant from "Ações da conversa" (ConversationAction.vue).
// POST /api/v1/accounts/:account_id/conversations/:conversation_id/metrica_resource_handoff
// Scoped to 'conversations' (like MetricaAiAssistAPI) so the backend resolves
// the conversation by display_id — the id the dashboard actually has.
class MetricaResourceHandoffAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  transfer(conversationId, resourceAgentId, instruction) {
    return axios.post(
      `${this.url}/${conversationId}/metrica_resource_handoff`,
      {
        resource_agent_id: resourceAgentId,
        instruction,
      }
    );
  }
}

export default new MetricaResourceHandoffAPI();
